<template>
  <div>
    <div class="col-md-12 mb-5" style="padding-right: 0">
      <b-form>
        <div class="row">
          <b-input
            placeholder="Tìm kiếm theo tên chức vụ"
            v-model="jobTitleSearch"
            class="col-md-4 btn-sm"
          ></b-input>
        </div>
      </b-form>
    </div>

    <div class="row">
      <div class="col-md-6">
        <h5 class="mb-3">Danh sách chức vụ</h5>
        <b-table
          :items="filteredJobTitleItems"
          :fields="jobTitleFields"
          class="table-bordered table-hover"
          @row-clicked="selectJobTitle"
          :tbody-tr-class="getJobTitleRowClass"
          :current-page="page"
          :per-page="perPage"
        >
          <template v-slot:cell(count)="row">
            <span class="d-flex justify-content-center">{{ row.item.count }}</span>
          </template>
          <template v-slot:cell(name)="row">
            <div class="font-weight-bolder cursor-pointer">{{ row.item.name }}</div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" no-caret right>
                <template slot="button-content">
                  <i style="font-size: 1rem; padding-right: 0px" class="flaticon2-settings"></i>
                </template>
                <b-dropdown-item @click.stop="editJobTitleDayLimit(row.item)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-pen"></i>
                    &nbsp; Chỉnh sửa
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <b-row class="mt-3">
          <b-col>
            <b-pagination-nav
              class="custom-pagination"
              v-model="page"
              :link-gen="linkGen"
              :number-of-pages="totalPages"
              use-router
              align="right"
            ></b-pagination-nav>
          </b-col>
        </b-row>
      </div>

      <div class="col-md-6">
        <h5 class="mb-3">
          Các thành viên:
          <span class="text-primary">{{ selectedJobTitle && selectedJobTitle.name }}</span>
        </h5>
        <div v-if="!selectedJobTitle" class="text-center text-muted py-5">
          <i class="flaticon2-information" style="font-size: 3rem; opacity: 0.3"></i>
          <p class="mt-3">Vui lòng chọn một chức vụ để xem danh sách thành viên</p>
        </div>
        <div v-else>
          <b-table
            :items="jobTitleMembersList"
            :fields="memberFields"
            class="table-bordered table-hover"
            :busy="jobTitleMembersLoading"
            small
          >
            <template v-slot:table-busy>
              <vcl-table :speed="5" :animate="true" :columns="4"></vcl-table>
            </template>
            <template v-slot:cell(count)="row">
              <span v-text="row.index + 1" class="d-flex justify-content-center"></span>
            </template>
            <template v-slot:cell(isActive)="row">
              <i
                v-bind:class="{
                  'fas fa-check text-success': row.item.isActive == 1,
                  'fas fa-minus-circle text-danger': row.item.isActive != 1,
                }"
              />
            </template>
          </b-table>
          <div
            v-if="jobTitleMembersList.length === 0 && !jobTitleMembersLoading"
            class="text-center text-muted py-3"
          >
            <p>Chức vụ này chưa có thành viên nào</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { VclTable } from 'vue-content-loading';
import { handleError } from '@/utils/common';

export default {
  name: 'DayLimitTab',
  components: { VclTable },
  data() {
    return {
      jobTitleSearch: '',
      jobTitleList: [],
      selectedJobTitle: null,
      jobTitleMembersList: [],
      jobTitleMembersLoading: false,
      page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
      perPage: 10,
      jobTitleFields: [
        {
          key: 'count',
          label: 'STT',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', textAlign: 'center', width: '8%' },
        },
        {
          key: 'name',
          label: 'Tên chức vụ',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        { key: 'actions', label: '', thStyle: { width: '10%' } },
      ],
      memberFields: [
        {
          key: 'count',
          label: 'STT',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', textAlign: 'center' },
        },
        {
          key: 'username',
          label: 'Tài khoản',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'employeeName',
          label: 'Họ và tên',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'storeName',
          label: 'Cửa hàng',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'isActive',
          label: 'Trạng thái',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
          tdClass: 'text-center',
        },
      ],
    };
  },
  computed: {
    filteredJobTitleItems() {
      const keyword = (this.jobTitleSearch || '').toLowerCase().trim();
      const list = keyword
        ? this.jobTitleList.filter((jt) => jt.name.toLowerCase().includes(keyword))
        : this.jobTitleList;
      return list.map((jt, i) => ({ ...jt, count: i + 1 }));
    },
    totalPages() {
      return Math.ceil(this.filteredJobTitleItems.length / this.perPage) || 1;
    },
  },
  created() {
    this.fetchJobTitleList();
  },
  methods: {
    fetchJobTitleList: async function () {
      try {
        const { data } = await ApiService.get('v1/job-titles');
        this.jobTitleList = data.data || [];
      } catch (error) {
        handleError(error);
      }
    },
    selectJobTitle: function (jt) {
      this.selectedJobTitle = jt;
      this.fetchJobTitleMembers(jt.id);
    },
    fetchJobTitleMembers: async function (jobTitleId) {
      this.jobTitleMembersLoading = true;
      try {
        const {
          data: { data: users },
        } = await ApiService.get(`v1/job-titles/${jobTitleId}/members`);
        this.jobTitleMembersList = users;
      } catch (error) {
        handleError(error);
      } finally {
        this.jobTitleMembersLoading = false;
      }
    },
    editJobTitleDayLimit: function (jt) {
      this.$router.push({
        name: 'day-limit-job-title',
        query: { jobTitleId: jt.id, jobTitleName: jt.name },
      });
    },
    getJobTitleRowClass: function (item) {
      if (this.selectedJobTitle && item.id === this.selectedJobTitle.id) {
        return 'table-active';
      }
      return '';
    },
    linkGen(pageNum) {
      return {
        query: {
          ...this.$route.query,
          page: pageNum,
        },
      };
    },
  },
};
</script>
